import styled, { createGlobalStyle } from "styled-components";

/** react-select menu is portaled to body; panel is fixed + stacked so menu must sit above it */
export const FilterPanelSelectMenuPortal = createGlobalStyle`
  .mds__menu-portal {
    z-index: 10050 !important;
  }
`;

const Wrapper = styled.div`
    z-index : 2;
    position : fixed;
    height : calc(100vh - 91px);
    inset: 90px 0% 0% auto;
    width : 600px;
    background : #fff;
    box-shadow : -2px 0  5px rgba(0, 0, 0, 0.2);
    flex-direction: column;
    align-items: flex-start;
    display: flex;
    .filter-panel-close{
        position : absolute;
        top : 16px;
        right : 8px;
        cursor : pointer;
        flex-shrink : 0;
        z-index : 1;
    }
    .head-part{
        width : 100%;
        padding : 16px 48px 16px 16px;
        box-sizing : border-box;
        border-bottom : solid thin #e6e6e6;
        min-height : 56px;
        h1{
            font-size : 24px;
            color : rgb(51,51,51);
            margin : 0;
            padding-right : 0;
        }
        p{
            font-size : 16px;
            line-height : 1.5;
            margin-top : 8px;
            margin-bottom : 0;
            color : rgb(101, 101, 101); 
        }
        p:first-child{
            margin-top : 0;
        }
    }
    .items{
        flex : 1;
        width : 100%;
        overflow : auto;
        display: flex;
        flex-direction: column;
    }
    .foot-part{
        background : #fafafa;
        border-top : solid thin #e6e6e6;
        padding : 16px;
        box-sizing : border-box;
        display : flex;
        width : 100%;
        justify-content : end;
        gap : 12px;
        align-items: center;
    }
    .foot-part-buttons{
        background : #fafafa;
        padding : 1px;
        display : flex;
        box-sizing : border-box;
        width : 25%;
        justify-content : end;
        gap : 10px;
    }

    .foot-part .ValidationMsg {
      color: #CD3030;
    }
`

export default Wrapper